import React from "react";
import AbtcAvatar from "../custom/Avatar";
import { AppBar, CardContent, IconButton, Typography } from "@material-ui/core";
import { connect } from "react-redux";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { FormattedMessage } from "react-intl";
import HeaderPageItem from "../custom/HeaderPageItem";
import { Link } from "react-router-dom";
import KycUsersListView from "./components/KycUsersListView";
import PageContainer, { CardPageItem } from "../custom/Page";
import PropTypes from "prop-types";
import SafewordDisplay from "./components/SafewordDisplay";
import SettingsIcon from "@material-ui/icons/Settings";

const KycDashboard = ({ currentUser }) => (
  <PageContainer removeSpacing>
    <HeaderPageItem style={{ height: 210 }}>
      <AppBar
        position="relative"
        style={{
          height: 110,
          paddingTop: 30,
          display: "flex",
          alignItems: "center",
        }}
      >
        <SafewordDisplay safeword={currentUser?.safeword} />
        <IconButton style={{ position: "absolute", left: 0, top: 0 }} component={Link} to="/logout">
          <ExitToAppIcon htmlColor="#23323C" style={{ transform: "rotate(180deg)" }} />
        </IconButton>
        <IconButton style={{ position: "absolute", right: 0, top: 0 }} component={Link} to="/more">
          <SettingsIcon htmlColor="#23323C" />
        </IconButton>
        <AbtcAvatar imageUrl={currentUser.photoUrl} disableLink size={160} avatarStyle={{ border: "8px rgba(254, 193, 44, 1) solid" }} style={{}} />
      </AppBar>
    </HeaderPageItem>
    <CardPageItem>
      <CardContent>
        <Typography variant="h5" align="center">
          {currentUser.name}
          <br />
          (<FormattedMessage id="app.enuns.ROLE_KYC" />)
        </Typography>
      </CardContent>
    </CardPageItem>
    <KycUsersListView />
  </PageContainer>
);

KycDashboard.propTypes = {
  currentUser: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    currentUser: state.user.user.me,
  };
}

export default connect(mapStateToProps)(React.memo(KycDashboard));
